let arr=[
    {name:'来源1',value:'来源1'},
    {name:'来源2',value:'来源2'}
]
export default arr